import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { ButtonContainer, SubmissionButton } from './submissionComplete.styled';
import { setEquityOrderFromUsage } from 'src/pages/equity/redux/actions';
import { useHistory, useLocation } from 'react-router';
import { GETEQUITYDETAILSFROMUSAGEDATA } from 'src/constants/productConstants';
import { useTranslation } from 'react-i18next';
import {getRoutePathWithParams, logErrorToConsole} from 'src/utils/util';

const SubmitScreenCTAButtonsContainer = ({
    sendUsageReportClickHandler,
    redirectToOrders,
    myCaseRefId,
    reportUsageFormObj,
    isNoUsageSubmitPage,
    onCTAButtonClick,
    fromOrdersList,
    myCaseResourceType,
    isSubmitClicked,
}) => {
    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();

    return (
        <ButtonContainer
            buttonContainerMarginTop={
                bannerHeight ? `calc(80% - ${bannerHeight})` : 'auto'
            }
            marginTop={'0'}
        >
            <SubmissionButton>
                <Button
                    id={'reportUsage-submit-submitScreenCTAButton'}
                    show={isNoUsageSubmitPage ? false : true}
                    // primary={!isSubmitClicked}
                    variant={isSubmitClicked ? ButtonStyles?.disabled : ButtonStyles?.primary}
                    width={'356px'}
                    backgroundColor={!isSubmitClicked && '#ffff'}
                    mobileWidth={'90%'}
                    height={'auto'}
                    padding={'10px'}
                    borderRadius={'40px'}
                    color={!isSubmitClicked && '#1010EB'}
                    margin={'5px'}
                    // fontSize={'15px'}
                    // fontFamily={'AvenirNextWorld Demi'}
                    clicked={sendUsageReportClickHandler}
                    disabled={isSubmitClicked}
                >
                    {t(
                        'reportUsage.submit.SubmitScreenCTAbuttonsContainer.sendUsageReports'
                    )}
                </Button>
            </SubmissionButton>
            {reportUsageFormObj?.products &&
                reportUsageFormObj?.products.some(
                    (item) => item.isAccountOwned
                ) &&
                myCaseResourceType !== 'reportPayment' && (
                    <SubmissionButton>
                        <Button
                        id={'reportUsage-submit-placeEquityButton'}
                            show={true}
                            // primary={!isSubmitClicked}
                            variant={!isSubmitClicked ? ButtonStyles?.primary : ButtonStyles.disabled}
                            width={'356px'}
                            backgroundColor={!isSubmitClicked && '#ffff'}
                            mobileWidth={'90%'}
                            height={'auto'}
                            padding={'10px'}
                            borderRadius={'40px'}
                            color={!isSubmitClicked && '#1010EB'}
                            margin={'5px'}
                            fontSize={'15px'}
                            fontFamily={'AvenirNextWorld Demi'}
                            clicked={() => {
                                try {
                                dispatch(
                                    setEquityOrderFromUsage(
                                        myCaseRefId,
                                        GETEQUITYDETAILSFROMUSAGEDATA.resourceType
                                    )
                                );
                                history.push({
                                    ...getRoutePathWithParams('/equity'),
                                    state: {
                                        from: location?.pathname
                                            ? location.pathname
                                            : null,
                                    },
                                });
                                 } catch (error) {
                                    logErrorToConsole(error);
                                  }
                            }}
                            disabled={isSubmitClicked}
                        >
                            {/* <a
                                style={{
                                    textDecoration: 'none',
                                    color: '#1010EB',
                                }}
                                href={`${process.env.WCMS_HOST_NAME}/view/content/spineAccountSelection?newEquityOrder=true&usageSSTRef=${myCaseRefId}&isNavigatedUrl=true`}
                            > */}
                            {t(
                                'reportUsage.submit.SubmitScreenCTAbuttonsContainer.placeEquityButton'
                            )}
                            {/* </a> */}
                        </Button>
                    </SubmissionButton>
                )}
            <SubmissionButton>
                <Button
                // color is going seperatly
                id={'reportUsage-submit-ctaButton'}
                    show={true}
                    // primary={true}
                    variant={ButtonStyles?.listViewApply}
                    width={'356px'}
                    mobileWidth={'90%'}
                    height={'auto'}
                    //backgroundColor={'#1010EB'}
                    borderRadius={'40px'}
                    padding={'10px'}
                    margin={'5px'}
                    // fontSize={'15px'}
                    //color={'#ffff'}
                    fontFamily={'AvenirNextWorld Demi'}
                    clicked={
                        isNoUsageSubmitPage
                            ? onCTAButtonClick
                            : () => redirectToOrders(true)
                    }
                >
                    {isNoUsageSubmitPage
                        ? t('equity.surgery.done')
                        : `${
                              fromOrdersList
                                  ? t(
                                        'scheduleSurgery.surgery.SurgeryReviewAndSuccess.goToOrders'
                                    )
                                  : t(
                                        'scheduleSurgery.surgery.SurgeryReviewAndSuccess.goToCalender'
                                    )
                          } `}
                </Button>
            </SubmissionButton>
        </ButtonContainer>
    );
};

export default SubmitScreenCTAButtonsContainer;
